import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useBillboardObject3d } from './hooks';
export const Billboard = (props) => {
    const groupRef = useRef(null);
    const { follow = false, lockY = false, children, rotation, isCameraOrbiting = false, ...groupProps } = props;
    useBillboardObject3d({ object3d: groupRef, rotation: isCameraOrbiting ? rotation : undefined, follow, lockY, isCameraOrbiting });
    return (_jsx("group", { ref: groupRef, ...groupProps, children: _jsx("group", { rotation: isCameraOrbiting ? undefined : rotation, children: children }) }));
};
export default Billboard;
